<template>
  <div class="about-history">
    <div class="decoration-element">
      <div class="decoration-element-2"></div>
    </div>
    <div class="text-group first-text-group">
      <h3 class="text-accent">{{ $t('about-history-1') }}</h3>
      <h1>{{ $t('about-history-2') }}</h1>
    </div>
    <table class="about-history-table">
      <tr v-for="y in years" :key="`row-${y.year}`">
        <td>
          <div class="text-group">
            <h1>{{ y.year }}</h1>
          </div>
        </td>
        <td>
          <div class="text-group">
            <p>{{ y.text }}</p>
          </div>
        </td>
      </tr>
    </table>
    <!-- GALLERY -->
    <div class="about-history-gallery">
      <div class="arrow">
        <span class="kcm" @click="changeItem(activeYearItem - 1)">D</span>
      </div>
      <div class="arrow">
        <span class="kcm" @click="changeItem(activeYearItem + 1)">B</span>
      </div>
      <template v-for="(y, i) in years">
        <transition :name="`show-${direction}`" :key="`transition-item-${i}`">
          <div
            v-if="activeYearItem === i"
            class="about-history-gallery-item"
            :style="{ backgroundImage: `url('${y.img}')` }"
            :key="`gallery-item-${i}`"
          >
            <div class="about-history-gallery-year">
              <div class="text-group">
                <h1>{{years[activeYearItem].year}}</h1>
              </div>
            </div>
            <div class="about-history-gallery-text">
              <div class="text-group">
                <p>{{years[activeYearItem].text}}</p>
              </div>
            </div>
          </div>
        </transition>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeYearItem: 0,
      interval: 8000,
      direction: 'right',
      rotation: null
    };
  },
  computed: {
    years() {
      return [
        {
          year: '1961',
          text: this.$t('about-history-1961'),
          img: require('../../assets/img/about/history/1961.jpg')
        },
        {
          year: '1963',
          text: this.$t('about-history-1963'),
          img: require('../../assets/img/about/history/1963.jpg')
        },
        {
          year: '1985',
          text: this.$t('about-history-1985'),
          img: require('../../assets/img/about/history/1985.jpg')
        },
        {
          year: '2000',
          text: this.$t('about-history-2000'),
          img: require('../../assets/img/about/history/2000.jpg')
        },
        {
          year: '2000-2003',
          text: this.$t('about-history-2000-2003'),
          img: require('../../assets/img/about/history/2000_2003.jpg')
        },
        {
          year: '2001-2005',
          text: this.$t('about-history-2001-2005'),
          img: require('../../assets/img/about/history/2001_2005.jpg')
        },
        {
          year: '2004',
          text: this.$t('about-history-2004'),
          img: require('../../assets/img/about/history/2004.jpg')
        },
        {
          year: '2007',
          text: this.$t('about-history-2007'),
          img: require('../../assets/img/about/history/2007.jpg')
        },
        {
          year: '2012',
          text: this.$t('about-history-2012'),
          img: require('../../assets/img/about/history/2012.jpg')
        },
        {
          year: '2015',
          text: this.$t('about-history-2015'),
          img: require('../../assets/img/about/history/2015.jpg')
        },
        {
          year: '2021',
          text: this.$t('about-history-2021'),
          img: require('../../assets/img/about/history/2021.jpg')
        },
        {
          year: '2022',
          text: this.$t('about-history-2022'),
          img: require('../../assets/img/about/history/2022.jpg')
        }
      ];
    }
  },
  methods: {
    changeItem(n) {
      this.stopRotation();
      this.direction = this.activeYearItem < n ? 'right' : 'left';
      if (n < 0) {
        this.activeYearItem = this.years.length - 1;
      } else if (n > this.years.length - 1) {
        this.activeYearItem = 0;
      } else {
        this.activeYearItem = n;
      }
      this.startRotation();
    },
    startRotation() {
      this.rotation = setInterval(() => {
        if (this.activeYearItem < this.years.length - 1) {
          this.activeYearItem += 1;
        } else {
          this.activeYearItem = 0;
        }
      }, this.interval);
    },
    stopRotation() {
      clearInterval(this.rotation);
    }
  },
  mounted() {
    this.startRotation();
  },
  destroyed() {
    this.stopRotation();
  }
};
</script>

<style lang="scss" scoped>
.about-history {
  padding: 50px $sidesPadding;
  position: relative;
  .about-history-table {
    margin: 30px auto;
    width: 60vw;
    tr {
      td {
        vertical-align: middle;
        padding: 10px 30px;
        h1 {
          white-space: nowrap;
        }
        p {
          margin: 0;
        }
      }
      td:first-child {
        text-align: center;
      }
    }
    tr:nth-of-type(odd) {
      background-color: rgba(178, 200, 210, 0.5);
    }
  }
  .about-history-gallery {
    align-items: flex-end;
    display: flex;
    height: 35vw;
    justify-content: flex-end;
    margin: 0 auto;
    position: relative;
    @include transition(all 0.6s $mainCubic);
    width: 60vw;
    .arrow {
      cursor: pointer;
      left: -60px;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      z-index: 2;
      .kcm {
        color: $mainColor;
        font-size: 30px;
      }
    }
    .arrow:hover {
      opacity: 0.8;
    }
    .arrow:nth-child(2) {
      left: initial;
      right: -60px;
    }
    .about-history-gallery-item {
      background-color: #000;
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
      height: 100%;
      left: 0;
      position: absolute;
      top: 0;
      width: 100%;
      z-index: 1;
    }
    .about-history-gallery-year,
    .about-history-gallery-text {
      background-color: $mainColor;
      color: #fff;
      left: 10px;
      position: absolute;
      top: 10px;
      padding: 0 15px 10px;
    }
    .about-history-gallery-text {
      bottom: -10px;
      left: initial;
      right: 10px;
      top: initial;
      padding: 10px;
      max-width: 60%;
      p {
        margin: 0;
      }
    }
  }
  .about-history-gallery::before {
    background-color: #b2c8d2;
    content: '';
    height: 70%;
    left: -2.5%;
    opacity: 0.5;
    position: absolute;
    top: 15%;
    width: 105%;
  }
  .about-history-gallery::after {
    background-color: #b2c8d2;
    content: '';
    height: 85%;
    left: -1.25%;
    position: absolute;
    top: 7.5%;
    width: 102.5%;
  }
}
@media screen and (max-width: 1600px) {
  .about-history {
    padding: 50px $sidesPadding1600;
  }
}
@media screen and (max-width: 1280px) {
  .about-history {
    padding: 40px $sidesPadding1280;
  }
}
@media screen and (max-width: 1000px) {
  .about-history {
    .about-history-table {
      margin: 25px 0;
      width: 100%;
    }
    .about-history-gallery {
      height: 50vw;
      width: 100%;
    }
  }
}
@media screen and (max-width: 600px) {
  .about-history {
    padding: $sidesPadding600;
  }
}
</style>